import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    if (process.env.NODE_ENV === "development") {
      console.log("ユーザーが認証されていません");
    }
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && allowedRoles.length > 0) {
    const userRoles = Array.isArray(user.roles) && user.roles.length > 0 ? user.roles : [user.role];
    const isAllowed = userRoles.some((role) => allowedRoles.includes(role));

    if (!isAllowed) {
      if (process.env.NODE_ENV === "development") {
        console.log("アクセス権限がありません:", {
          userRoles,
          allowedRoles,
          path: location.pathname,
        });
      }

      let redirectPath = "/";
      if (userRoles.includes("SYSTEM_ADMIN")) {
        redirectPath = "/system-admin/dashboard";
      } else if (userRoles.includes("COMPANY_ADMIN")) {
        redirectPath = "/company-admin/dashboard";
      } else if (userRoles.includes("BRAND_ADMIN")) {
        redirectPath = "/brand-admin/dashboard";
      } else if (userRoles.includes("STORE_ADMIN")) {
        redirectPath = user.storeId
          ? `/store-admin/${user.storeId}/dashboard`
          : "/login";
      } else if (userRoles.includes("STORE_STAFF")) {
        redirectPath = user.storeId ? `/pos/${user.storeId}` : "/login";
      } else {
        redirectPath = "/login";
      }

      return <Navigate to={redirectPath} state={{ from: location }} replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
